/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST

// 付款管理新增(新)
export const createPaymentManagerDataNew = params => {
  return axios.post(`${base}/payment-applications/v2`, params)
}

// 付款管理修改(新)
export const updatePaymentManagerDataNew = params => {
  return axios.put(`${base}/payment-applications/${params.id}/v2`, params)
}



// WEBPACK FOOTER //
// ./src/views/payment-manager-new/payment-manager.api.js